var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-capsule",
    { attrs: { formTitle: _vm.$t("webheader.back_office"), writable: false } },
    [
      _c("template", { slot: "formcontent" }, [
        _vm._v("\n      Workflow document "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v("\n    Workflow paiement\n  "),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }